import { Component, ChangeDetectionStrategy, inject } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { LayoutService } from '../../core/services/layout.service';
import { MatSidenavModule } from '@angular/material/sidenav';

@Component({
    selector: 'fk-main-layout',
    standalone: true,
    imports: [RouterOutlet, HeaderComponent, SidebarComponent, MatSidenavModule],
    templateUrl: './main-layout.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainLayoutComponent {
    layoutService = inject(LayoutService);
}
